import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYahoo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_5626_43893)",
			children: [/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.42188 0H19.5781C22.2935 0.00721875 24.4928 2.20655 24.5 4.92164V19.0781C24.4928 21.7934 22.2935 23.9927 19.5784 23.9999L5.42188 24C2.70659 23.9927 0.507312 21.7934 0.500094 19.0783L0.5 4.92188C0.507312 2.20655 2.70659 0.00721875 5.42173 0H5.42188Z",
				fill: "#5F01D1"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M5.49683 8.8048H8.16814L9.72364 12.7842L11.2994 8.8048H13.9001L9.98389 18.2255H7.36629L8.43837 15.7292L5.49692 8.8048H5.49683ZM16.9287 11.9845H14.0157L16.6011 5.77344L19.5035 5.77358L16.9287 11.9845ZM14.7787 12.5789C15.6725 12.5789 16.397 13.3035 16.397 14.1971C16.397 15.0908 15.6725 15.8153 14.7787 15.8153C13.8851 15.8153 13.1607 15.0908 13.1607 14.1971C13.1607 13.3035 13.8852 12.5789 14.7787 12.5789Z",
				fill: "white"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5626_43893",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(0.5)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgYahoo);
export { ForwardRef as ReactComponent };
